export default [
    {
        "error_id": "CXWSEL-01",
        "data": [
            {
                "cross_section": "9644",
                "left_wsel": 2630.99,
                "right_wsel": 2630.98,
                "left_profile": "100yr (1%)",
                "right_profile": "Fway",
                "side": "left"
            },
            {
                "cross_section": "9669    BR U",
                "left_wsel": 2635.07,
                "right_wsel": 2635.42,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "9693",
                "left_wsel": 2635.6,
                "right_wsel": 2635.88,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "9835",
                "left_wsel": 2635.62,
                "right_wsel": 2635.94,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "10121",
                "left_wsel": 2642.86,
                "right_wsel": 2645.91,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "10181",
                "left_wsel": 2642.9,
                "right_wsel": 2645.9,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "10516",
                "left_wsel": 2642.91,
                "right_wsel": 2645.87,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "10957",
                "left_wsel": 2643.05,
                "right_wsel": 2645.88,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "11009",
                "left_wsel": 2643.16,
                "right_wsel": 2645.89,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "11022   BR U",
                "left_wsel": 2643.65,
                "right_wsel": 2645.89,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "11022   BR D",
                "left_wsel": 2643.53,
                "right_wsel": 2645.87,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "11039",
                "left_wsel": 2643.15,
                "right_wsel": 2645.71,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "11272",
                "left_wsel": 2644.87,
                "right_wsel": 2645.98,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "13326",
                "left_wsel": 2655.51,
                "right_wsel": 2655.86,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "13807",
                "left_wsel": 2660.32,
                "right_wsel": 2660.35,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "14913",
                "left_wsel": 2675.56,
                "right_wsel": 2675.68,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "14964",
                "left_wsel": 2675.54,
                "right_wsel": 2675.68,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "16246   BR U",
                "left_wsel": 2683.67,
                "right_wsel": 2683.77,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "16266",
                "left_wsel": 2684.02,
                "right_wsel": 2684.1,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "16305",
                "left_wsel": 2684.04,
                "right_wsel": 2684.14,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "18433",
                "left_wsel": 2705.68,
                "right_wsel": 2705.89,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            },
            {
                "cross_section": "18856",
                "left_wsel": 2712.25,
                "right_wsel": 2712.35,
                "left_profile": "500yr (0.2%)",
                "right_profile": "Fway",
                "side": "right"
            }
        ]
    }
]